/**
 * Applies the self-funding route guard (`resolveSelfFundRoute`) for the current client and session.
 * Used by every consumer step and, through `withSelfFundRouteGuard`, by the legacy paid pages.
 */
import {
  getSelfFundAccess,
  resolveSelfFundRoute,
  type SelfFundRouteTarget,
} from '../lib/self-fund-access';
import { useSelector } from 'react-redux';
import { selectSession } from '@/model';
import { useIsConsumerSession } from '@/hooks/use-app-mode';

export function useSelfFundRouteGuard(clientId: string, target: SelfFundRouteTarget) {
  const { clientStripe } = useSelector(selectSession);
  const isConsumerSession = useIsConsumerSession();

  return resolveSelfFundRoute(target, {
    clientId,
    isConsumerSession,
    access: getSelfFundAccess(clientStripe),
  });
}
